<div class="page">
  <div class="page__title add-child-header">
    <div>NYCPS Resources</div>
  </div>
  <div>
    <ul>
      <li *ngFor="let link of links">
        <a [href]="link.url" target="_blank" rel="noopener noreferrer">{{ link.text }}<span class="k-sr-only"> (opens in new tab)</span></a>
      </li>
    </ul>
  </div>
</div>